export function getlineNumberofChar(str: string, position: number) {
  const perLine = str.split("\n");
  let total_length = 0;
  for (const [index, value] of perLine.entries()) {
    total_length += value.length;
    if (total_length >= position) return index + 1;
  }
  return perLine.length;
}
